<ng-container *ngIf="state$ | async as state">
  <button class="mb-facet-heading"
          data-cy="mb-facet-heading"
          (click)="toggleGroup($event)">
    {{ facet.name }}
    <div class="collapse-icon mb-facet-collapse-button"></div>
    <div class="expand-icon mb-facet-expand-button"></div>
  </button>
  <div [ngClass]="{'d-block': state.toggled === facetState.EXPANDED}"
       [@smoothCollapse]="state.toggled === facetState.EXPANDED && 'final' || 'initial'">
    <ng-container *ngFor="let value of facet.values | slice: 0:state.topVisible, index as i">
      <a #facetValue
         rel="nofollow"
         routerLink="./"
         [ngClass]="[isDesktopDevice ? 'is-desktop-device' : '' , 'value']"
         [queryParams]="getLinkParams(value)"
         [class.selected]="value.selected"
         [attr.data-cy]="'mb-facet-' + i"
         (click)="onFacetClick()">
        <span>
          <span *ngIf="!value?.displayName" class="label" [innerHTML]="value?.name | safeHtml"></span>
          <span *ngIf="value?.displayName" class="label" [innerHTML]="value?.displayName | safeHtml"></span>
          <span class="count">{{ value.count }}</span>
        </span>
      </a>
    </ng-container>

    <div class="more" data-cy="more">
      <div [ngClass]="{'d-block': state.maxVisible > state.topVisible}"
           [@smoothCollapse]="state.maxVisible > 0 && state.maxVisible < facet.values.length ? 'initial' : 'final'">
        <ng-container
          *ngFor="let value of facet.values | slice: state.topVisible:state.maxVisible, index as i">
          <a #facetValue
             class="value"
             rel="nofollow"
             routerLink="./"
             [queryParams]="getLinkParams(value)"
             [class.selected]="value.selected"
             [attr.data-cy]="'mb-facet-' + i"
             (click)="onFacetClick()">
            <span>
              <span *ngIf="!value?.displayName" class="label" [innerHTML]="value?.name | safeHtml"></span>
              <span *ngIf="value?.displayName" class="label" [innerHTML]="value?.displayName | safeHtml"></span>
              <span class="count">{{ value.count }}</span>
            </span>
          </a>
        </ng-container>
      </div>
      <button *ngIf="state.maxVisible > state.topVisible"
              (click)="decreaseVisibleValues()"
              class="cx-action-link"
              data-cy="mb-action-link-decrease"
              [innerHTML]="'productList.showLess' | mbTranslate">
      </button>
      <button *ngIf="state.maxVisible > 0 && state.maxVisible < facet.values.length"
              (click)="increaseVisibleValues()"
              class="cx-action-link"
              data-cy="mb-action-link-increase"
              [innerHTML]="'productList.showMore' | mbTranslate">
      </button>
    </div>
  </div>
</ng-container>

